export default __webpack_public_path__ + "static/media/tooth.4b556be3.png";